/* eslint-disable camelcase */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { connect } from 'react-redux';
import FavouriteProductsSlider from 'components/favourite-products-slider';

class CmsMostPurchasedCumulus extends PureComponent {
    static propTypes = {
        logged_out_text: PropTypes.string,
        cumulus_not_linked_text: PropTypes.string,
        title: PropTypes.string,
        most_purchased_cumulus: PropTypes.shape({
            link: PropTypes.shape({ to: PropTypes.string, label: PropTypes.string }),
            //products: PropTypes.array,
        }),
        hasCumulus: PropTypes.bool.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        routerRegistry: PropTypes.object.isRequired,
        endpoints: PropTypes.object.isRequired,
        favoriteProducts: PropTypes.array.isRequired,
        populateFavoriteProducts: PropTypes.func.isRequired,
    };


    render() {
        const { logged_out_text, cumulus_not_linked_text, title, most_purchased_cumulus } = this.props;
        return (
            <FavouriteProductsSlider
                logged_out_text={ logged_out_text }
                cumulus_not_linked_text={ cumulus_not_linked_text }
                title={ title }
                most_purchased_cumulus={ most_purchased_cumulus }
            />
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        hasCumulus: 'user.cumulus_connected',
        isAuthenticated: 'user.isAuthenticated',
        routerRegistry: 'router.registry',
        endpoints: 'router.endpoints',
        favoriteProducts: 'user.favoriteProducts',
    }),
    reduxUtils.mapDispatchToProps({
        populateFavoriteProducts: 'user.populateFavoriteProducts',
    }),
)(CmsMostPurchasedCumulus);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/most-purchased-cumulus/index.js